@if (videoDetails) {
  <div class="video-wrapper">
    <vg-player (onPlayerReady)="onPlayerReady($event)">
      <vg-overlay-play class="custom-overlay-play"></vg-overlay-play>
      <vg-buffering></vg-buffering>
      <vg-controls>
        <vg-play-pause></vg-play-pause>
        <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
        <!-- DO NOT WANT THEM TO HAVE ABILITY TO FAST FORWARD UNTIL THEY HAVE SEEN THE FULL VIDEO!!! -->
        <vg-scrub-bar [vgSlider]="enableTimeSlider" [ngClass]="{'no-pointer-events': !enableTimeSlider}">
          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
        </vg-scrub-bar>
        <!-- <vg-time-display vgProperty="left" vgFormat="mm:ss"></vg-time-display> -->
        <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
        <vg-mute></vg-mute>
        <vg-volume></vg-volume>
        <vg-fullscreen></vg-fullscreen>
      </vg-controls>
      <video [vgMedia]="media" #media id="singleVideo" preload="auto" crossorigin>
        <!--
        <source src="http://static.videogular.com/assets/videos/videogular.mp4" type="video/mp4">
        <source src="http://static.videogular.com/assets/videos/videogular.ogg" type="video/ogg">
        <source src="http://static.videogular.com/assets/videos/videogular.webm" type="video/webm">
        -->
        <source [src]="videoDetails.url" type="video/mp4">
      </video>
    </vg-player>
  </div>
}